<template>
  <div class="text-info-block">
    <el-dialog
      :visible.sync="visible"
      @close="closeDialog"
      title="上传付款凭证"
      width="800px"
      top="3vh"
    >
      <el-form
        :model="ruleForm"
        :rules="rules"
        class="demo-ruleForm"
        label-position="top"
        ref="ruleForm"
      >
        <el-form-item label="付款凭证" prop="upload">
          <el-upload
            ref="uploadPaymentVoucher"
            :action="`${$store.state.user.urlLink}api/ajax_img`"
            :before-upload="beforeAvatarUpload"
            :file-list="fileList"
            :on-error="handleError"
            :on-remove="handleRemove"
            :on-success="handleSuccess"
            accept=".jpg, .jpeg, .png"
            class="upload-payment-voucher"
            list-type="picture"
          >
            <el-button size="small" type="primary">点击上传</el-button>
            <div class="el-upload__tip" slot="tip">
              请上传jpg、png格式的付款凭证截图。上传的文件大小不能超{{
                $store.state.user.maxFileName
              }}。<span style="color: #f46c6c"
                >上传成功后请检查缩略图是否正常显示，若不正常，请重新上传！</span
              >
            </div>
          </el-upload>
        </el-form-item>

        <div class="alipay">
          <h3 style="line-height: 1; margin: 0 0 10px 0">
            通过如下三种方式之一支付，并上传支付截图。金额参见会议通知或咨询会务老师。
          </h3>
          <div class="flex" style="justify-content: space-between">
            <div style="width: 48%">
              <p>A.使用储蓄卡/信用卡/公务卡直接扫下码支付【方便快捷，推荐】</p>
              <!-- <img style="width: 200px" src="@/assets/imgs/bank-quankuan2.png" /> -->
              <img style="width: 200px" src="@/assets/imgs/bank-quankuan.png" />
            </div>

            <div style="width: 48%">
              <p>
                B.无需发票报销者，享受9折报名优惠，请直接扫下方支付宝二维码支付【仅限自费参会者】
              </p>

              <!-- <img style="width: 200px" src="@/assets/imgs/alipay-geren2.jpeg" /> -->
              <img style="width: 200px" src="@/assets/imgs/alipay-geren.png" />
            </div>
          </div>

          <div>
            <p style="magirn: 0">
              C.先个人支付，拿到发票后办理对公汇款，退还个人支付部分【适用于要求必须对公汇款的单位】
              您可先用个人支付宝扫右上方二维码完成支付，收到我们提供的发票等报销材料后，您可在30天内通过对公汇款等形式缴费，收到汇款后我方将全额退还个人支付部分。
              <!-- 对公汇款账号为： 户名：北京光锥时空科技有限公司 开户行：招商银行股份有限公司北京清华园科技金融支行 账号：110952528310501 -->
              对公汇款账号为： 户名：北京文雅信达科技有限公司
                开户行：招商银行北京金融街支行 账号： 110936956910201
            </p>
          </div>
        </div>

      </el-form>

      <span class="dialog-footer" slot="footer">
        <!-- <el-button @click="closeDialog">取 消</el-button> -->
        <el-button
          @click="submit('ruleForm')"
          type="primary"
          :loading="submitLoading"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import * as api from '@/api/user'

export default {
  name: 'ConfirmQuotation',
  props: {
    dialogVisible: {
      // dialog展示、隐藏
      // required: true, // 是否必填
      type: Boolean,
      default: false
    },
    checkedInfo: {
      // dialog展示、隐藏
      // required: true, // 是否必填
      type: Object
    }
  },
  computed: {
    // 计算属性的 监听 dialogVisible的变动
    visible: {
      get: function () {
        // `this` 指向 vm 实例
        return this.dialogVisible
      },
      set: function () {}
    },
    // 计算属性的 监听 checkedInfo的变动
    checked: {
      get: function () {
        // `this` 指向 vm 实例
        return this.checkedInfo
      },
      set: function () {}
    }
  },
  data() {
    // 校验文件上传
    const uploadFile = (rule, value, callback) => {
      if (this.fileList.length === 0) {
        callback(new Error('请上传文件'))
      } else {
        callback()
      }
    }

    return {
      // 上传文件的列表
      ruleForm: {},
      fileList: [],
      submitLoading: false,
      rules: {
        upload: [{ required: true, validator: uploadFile, trigger: 'blur' }]
      }
    }
  },
  created() {},
  methods: {
    /**
     * @description 限制上传文件的大小
     */
    beforeAvatarUpload(file) {
      // const isJPG = file.type === 'image/jpeg';
      const isOverSize =
        file.size / 1024 / 1024 <= this.$store.state.user.maxFile

      // if (!isJPG) {
      //   this.$message.error('上传头像图片只能是 JPG 格式!');
      // }
      if (!isOverSize) {
        this.$message.error(
          `上传的文件大小不能超过${this.$store.state.user.maxFileName}!`
        )
      }
      return isOverSize
    },

    /**
     * @description 上传失败的钩子函数
     */
    handleError(err, file, fileList) {
      // this.$message.error('上传失败，请再次尝试！')
      this.$message.error(err.error_msg)
    },

    /**
     * @description 上传成功的钩子函数
     */
    handleSuccess(response, file, fileList) {
      // 只保留一张图片
      if (fileList.length > 1) {
        fileList.splice(0, 1)
      }
      this.$refs.uploadPaymentVoucher.clearFiles()
      this.fileList = []
      if (response.error_msg == '请登录') {
        this.$message.error('登录之后，才能允许上传文件，请先登录！')
        this.fileList = []
        // setTimeout(() => {
        //   this.toLogin()
        // }, 1000)
      } else if (response.error_code == 1) {
        // this.$message.error('上传失败，请重新再试')
        this.$message.error(response.error_msg)
        this.fileList = []
      } else {
        this.fileList = fileList.slice(-10) // 最大10个文件
      }
    },

    /**
     * @description 删除文件
     */
    handleRemove(file, fileList) {
      this.fileList = fileList
    },

    /**
     * @description 上传付款凭证
     */
    submit(formName) {
      const _this = this
      // if (_this.fileList.length == 0) {
      //   _this.$message.error('请先上传支付凭证')
      //   return
      // }
      _this.$refs[formName].validate((valid) => {
        if (valid) {
          const _param = {
            pay_img: '',
            id: _this.checked.id
          }
          _this.fileList.map((item) => {
            _param.pay_img = _param.pay_img + ',' + item.response.data
          })
          _param.pay_img = _param.pay_img.substring(1)
          _this.submitLoading = true
          // api
          //   .submitPayImg(_param)
          api
            .fileSubmitPayImg(_param)
            .then((res) => {
              // const _data = res.data
              _this.submitLoading = false
              _this.$message.success('提交成功！')
              _this.closeDialog() // 关闭dialog
              _this.$emit('getList') // 刷新订单
            })
            .catch((err) => {
              console.log(err)
              _this.submitLoading = false
            })
        }
      })
    },

    /**
     * @description 关闭dialog
     */
    closeDialog() {
      this.$emit('update:dialogVisible', false)
    }
  }
}
</script>

<style lang="scss" scoped>
.text-info-block {
  /deep/.el-dialog {
    background: #f1f1f1;

    .el-dialog__body {
      padding-top: 0;
    }

    .el-form {
      .el-form-item__label {
        padding: 0;
      }

      .el-upload__tip {
        margin: 0;
        line-height: 1.5;
      }

      .flex {
        display: flex;
        justify-content: space-around;
      }

      .alipay {
        h4 {
          text-align: center;
          font-size: 14px;
          color: #606266;
          margin: 0 0 10px 0;
          font-weight: normal;
        }

        img {
          display: block;
          width: 140px;
          margin: 0 auto;
        }
      }

      p {
        line-height: 1.5;
        margin: 10px 0 0 0;
      }

      .voucher-example {
        text-align: center;

        p {
          margin: 0 0 10px 0;
        }

        img {
          display: block;
          width: 200px;
          margin: 0 auto;
        }
      }
    }

    .el-upload__tip {
      font-size: 14px;
    }

    .el-dialog__footer {
      text-align: center;
    }
  }
}
</style>


